import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
// import { Contact } from 'src/modules/shared/Models/Contact';
import { catchError, retry } from 'rxjs/operators';
import { AppConfigService } from 'src/modules/shared/services/app-config.service';


@Injectable({
    providedIn: 'root'
})
export class AnnonceModelServiceService {
  //baseURL = environment.AppUrl + '/api/App/';
  public baseURL: string;

  constructor(private http: HttpClient, private appConfig: AppConfigService) {
    this.baseURL = this.appConfig.getAppConfig().AppUrl + '/api/App/';

  }


    // GET active annoncement
    getActiveAnnoncement(url, body): Observable<any> {
        return this.http.get<object>(this.baseURL + url, { params: body });
    }
    // Error handling
    //  handleError(error) {
    //     let errorMessage = '';
    //     if (error.error instanceof ErrorEvent) {
    //       // Get client-side error
    //       errorMessage = error.error.message;
    //     } else {
    //       // Get server-side error
    //       errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    //     }
    //     window.alert(errorMessage);
    //     return throwError(errorMessage);
    //   }
}

// export interface annoncementModel {
//   title:string;
//   description:string;
//   }


